module.exports = __webpack_public_path__ + "img/plus.9f051df2.svg";